"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComponentName = getComponentName;
exports.oxfordJoin = oxfordJoin;
exports.oxfordJoinSingular = oxfordJoinSingular;
exports.pluralizeCount = pluralizeCount;
exports.timeoutAsync = timeoutAsync;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _lodash = require("lodash");

function getComponentName(Component) {
  if (!(0, _lodash.isObject)(Component)) {
    return 'Component is not an object';
  }

  return "".concat(Component.displayName || Component.name || 'Component');
} // Join ['one', 'two', 'three'] as "one, two, and three"


function oxfordJoin(words, joinWord) {
  if (!joinWord) {
    joinWord = 'and';
  }

  if (words.length === 1) {
    return words[0];
  } else if (words.length === 2) {
    return "".concat(words[0], " ").concat(joinWord, " ").concat(words[1]);
  } else {
    return "".concat(words.slice(0, words.length - 1).join(', '), ", ").concat(joinWord, " ").concat(words[words.length - 1]);
  }
} // Join ['apple', 'banana', 'cranberry'] as "an apple, banana, and cranberry"


function oxfordJoinSingular(words, joinWord) {
  var newWords = [addArticle(words[0])].concat((0, _toConsumableArray2.default)(words.slice(1, words.length)));
  return oxfordJoin(newWords, joinWord);
}

function pluralizeCount(count, word) {
  count !== 1 && (word = word + 's');
  return "".concat(count, " ").concat(word);
}

function timeoutAsync(delay) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, delay);
  });
}